import playWheelsDefaults from '../4play-wheels/config.js';
import { initQuickView } from './quickView.js';

window.Convermax.closeQuickView = () => {
  document.getElementById('popupQuickview')?.close();
};

window.Convermax.quickView = (e) => {
  const root = e.target.closest('[data-quick-view]');
  if (!root) {
    return;
  }

  initQuickView(root);

  root.querySelector('button')?.click();
};

export default {
  includes: ['shopify-generic', '4play-wheels'],
  ...playWheelsDefaults,
  SearchRequestDefaults: {
    ...playWheelsDefaults.SearchRequestDefaults,
    pageSize: 24,
  },
  Widgets: [
    ...playWheelsDefaults.Widgets.filter((w) => w.name !== 'SearchHeader'),
    {
      name: 'SearchHeader',
      pageSizes: [10, 24, 48],
    },
  ],
};
